import React, { useCallback, useMemo } from 'react'
import getPictures from 'lib/getCarPictures'

import CarDetails from 'components/organisms/CarDetails'
import CarPrices from 'components/organisms/Sessions/CarPrices'

import CarDetailsPageTitle from '../CarDetails/CarDetailsPageTitle'

export default function SessionsCarDetails({
  cars,
  plate,
  session,
  isFetching,
  isFetchingSession,
  updatePlatePricing,
  edit,
  prices,
  toggleChangePrice,
  toggleEditGroupPrice,
  setGroupPrice,
  setShowDetails,
}) {
  const car = useMemo(
    () =>
      plate &&
      cars.find((car) => car.plate.toLowerCase() === plate.toLowerCase()),
    [cars, plate]
  )

  const pictures = useMemo(
    () => getPictures(car?.pictureurl),
    [car?.pictureurl]
  )

  const readOnly = useMemo(
    () => isFetching || isFetchingSession || !!session.confirmationAcceptedAt,
    [isFetching, isFetchingSession, session.confirmationAcceptedAt]
  )

  const handleSavePricing = useCallback(
    (plate, prices) => {
      updatePlatePricing(session.sessionId, plate, prices)
    },
    [session, updatePlatePricing]
  )

  const carPrices = useMemo(
    () => (
      <CarPrices
        plate={car.plate}
        prices={prices[car.plate]}
        border
        vertical
        handleChangeGroupPrice={setGroupPrice}
        toggleEditGroupPrice={toggleEditGroupPrice}
        handleChangePrice={(e) => {
          toggleChangePrice(car.plate, handleSavePricing)
        }}
        edit={edit[car.plate]}
        readOnly={readOnly}
      />
    ),
    [
      car.plate,
      prices,
      readOnly,
      setGroupPrice,
      toggleEditGroupPrice,
      edit,
      handleSavePricing,
      toggleChangePrice,
    ]
  )

  return (
    <div className="content-container" data-testid="car-details">
      <>
        <CarDetailsPageTitle
          setShowDetails={setShowDetails}
          cars={cars}
          plate={plate}
        />
        {car && (
          <CarDetails
            car={car}
            pictures={pictures}
            showAppealing
            rightBottom={carPrices}
          />
        )}
      </>
    </div>
  )
}
